import { HiddenCheckbox, IconBall, Slider, ToggleContainer } from "./styles"


export const ToggleDarkLight = (props) => {
    const {isChecked, handleToggle} = props;
    return(
        <div>
            <ToggleContainer>
                <HiddenCheckbox checked={isChecked} onChange={handleToggle} />
                <Slider checked={isChecked} />
                <IconBall checked={isChecked}>
                    {isChecked ? '☀️' : '🌙'}
                </IconBall>
            </ToggleContainer>
      </div>
    )

}